import { useState } from 'react';
import { useLayoutEffect } from '@hooks/useIsomorphicLayoutEffect';

const NARROW_GALLERY_MEDIA_QUERY = '(max-width: 987px)';

/**
 * True when the gallery is in carousel/slider layout, i.e. below the
 * `tablet-xl` breakpoint (988px) where the grid kicks in.
 */
const useNarrowGalleryViewport = () => {
  const [matches, setMatches] = useState(false);

  useLayoutEffect(() => {
    const mq = window.matchMedia(NARROW_GALLERY_MEDIA_QUERY);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return matches;
};

export default useNarrowGalleryViewport;
